import React from "react"
import styled from "styled-components"
import { useStaticQuery, graphql } from "gatsby"
import WPLink from "components/shared/WPLink"

const FooterNavWrap = styled.div`
	h5 {
		color: ${props => props.theme.colors.secondary};
		font-family: ${props => props.theme.font.family.black};
		text-transform: uppercase;
		font-size: ${props => props.theme.font.size.md};
		margin-bottom: 1.5rem;
	}

	ul {
		margin-bottom: 2rem;
		list-style: none;
		padding: 0;
		li {
			padding-left: 0;
			&:before {
				display: none;
			}
		}
		a {
			font-size: ${props => props.theme.font.size.base};
			font-family: ${props => props.theme.font.family.body};
			color: ${props => props.theme.colors.white};
			text-decoration: none;
			
			/* &:hover {
				color: ${props => props.theme.colors.grey1};
			} */
		}
	}
`

const FooterMenu = (props) => {
	const data = useStaticQuery(graphql`
		query {
			footer1: allWpMenu(filter: {locations: {eq: FOOTER1}}) {
				edges {
					node {
						...menuFragment
					}
				}
			}
			footer2: allWpMenu(filter: {locations: {eq: FOOTER2}}) {
				edges {
					node {
						...menuFragment
					}
				}
			}
			footer3: allWpMenu(filter: {locations: {eq: FOOTER3}}) {
				edges {
					node {
						...menuFragment
					}
				}
			}
		}
	`)

	let menu
	switch (props.menu) {
		case 1:
			menu = data.footer1.edges
			break;
		case 2:
			menu = data.footer2.edges
			break;
		case 3:
			menu = data.footer3.edges
			break;

		default:
				break;
	}

	const node = menu[0]?.node

	if (node?.menuItems?.nodes) {
			return(
				<FooterNavWrap>
					<h5 dangerouslySetInnerHTML={{ __html: node.name}} />
					<nav>
						<ul>
							{
								node.menuItems.nodes.map((node, i) => {
									if (node.target !== null) {
										return (
											<li key={i}>
												<a href={node.url} target={node.target} rel="noopener noreferrer">{node.label}</a>
											</li>
										)
									} else {
										return (
											<li key={i}>
												<WPLink url={node.url}>{node.label}</WPLink>
											</li>
										)
									}
								})
							}
						</ul>
					</nav>
				</FooterNavWrap>
			)
	} else return ""
}

export const menuFragment = graphql`
	fragment menuFragment on WpMenu {
		name
		menuItems {
			nodes {
				url
				target
				label
			}
		}
	}
`

export default FooterMenu